import { render } from "./PointAlert.vue?vue&type=template&id=6664d5d5&scoped=true"
import script from "./PointAlert.vue?vue&type=script&lang=js"
export * from "./PointAlert.vue?vue&type=script&lang=js"

import "./PointAlert.vue?vue&type=style&index=0&id=6664d5d5&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6664d5d5"]])

export default __exports__